import { NavItem } from './nav-item/nav-item';


// This Menu for 'Admin'
export const navItems: NavItem[] = [
  {
    displayName: 'Dashboard',
    iconName: 'layout-dashboard',
    bgcolor: 'success',
    route: '/dashboards/dashboard',
  },
  {
    displayName: 'Task',
    iconName: 'list-details',
    bgcolor: 'accent',
    route: 'tasks',
    children: [
      {
        displayName: 'Add Task',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'tasks/add-edit-task/0',
      },
      {
        displayName: 'Pending',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'tasks/task-management/Pending',
      },
      {
        displayName: 'Accepted',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'tasks/task-management/Accepted',
      },
      {
        displayName: 'Started',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'tasks/task-management/Started',
      },
      {
        displayName: 'On Hold',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'tasks/task-management/On Hold',
      },
      {
        displayName: 'Completed',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'tasks/task-management/Completed',
      },
      {
        displayName: 'Cancel',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'tasks/task-management/Cancel',
      },
    ]
  },
  {
    displayName: 'Go To Home',
    iconName: 'home',
    bgcolor: 'success',
    route: 'starter/go-to-home',
  },
  {
    displayName: 'Manager',
    iconName: 'device-desktop-cog',
    bgcolor: 'warning',
    route: 'starter/manager',
  },
  {
    displayName: 'Salesman',
    iconName: 'users-plus',
    bgcolor: 'success',
    route: 'starter/salesman',
  },
  {
    displayName: 'Installer',
    iconName: 'user-cog',
    bgcolor: 'error',
    route: 'starter/installer',
  },
  {
    displayName: 'Notification',
    iconName: 'bell',
    bgcolor: 'warning',
    route: 'starter/notification',
  },
  {
    displayName: 'Masters',
    iconName: 'database-cog',
    bgcolor: 'error',
    route: 'masters',
    children: [
      {
        displayName: 'City',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'masters/city',
      },
      {
        displayName: 'Category',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'masters/category',
      },
      {
        displayName: 'Products',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'masters/products',
      },
    ]
  },
  {
    displayName: 'Reports',
    iconName: 'clipboard-list',
    bgcolor: 'accent',
    route: 'starter/reports',
    children: [
      {
        displayName: 'Task Report',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'starter/reports/task-report',
      },
      {
        displayName: 'City Wise Task Report',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'starter/reports/city-task-report',
      },
      {
        displayName: 'Payment Summary',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'starter/reports/paid-unpiad-report',
      },
      {
        displayName: 'Location Summary',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'starter/reports/location-summary',
      },
    ],
  },
]

// This Menu for 'Manager'
export const navItems2: NavItem[] = [
  {
    displayName: 'Dashboard',
    iconName: 'layout-dashboard',
    bgcolor: 'success',
    route: '/dashboards/dashboard',
  },
  {
    displayName: 'Task',
    iconName: 'list-details',
    bgcolor: 'accent',
    route: 'tasks',
    children: [
      {
        displayName: 'Add Task',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'tasks/add-edit-task/0',
      },
      {
        displayName: 'Pending',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'tasks/task-management/Pending',
      },
      {
        displayName: 'Accepted',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'tasks/task-management/Accepted',
      },
      {
        displayName: 'Started',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'tasks/task-management/Started',
      },
      {
        displayName: 'On Hold',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'tasks/task-management/On Hold',
      },
      {
        displayName: 'Completed',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'tasks/task-management/Completed',
      },
      {
        displayName: 'Cancel',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'tasks/task-management/Cancel',
      },
    ]
  },
  {
    displayName: 'Go To Home',
    iconName: 'home',
    bgcolor: 'success',
    route: 'starter/go-to-home',
  },
  {
    displayName: 'Salesman',
    iconName: 'users-plus',
    bgcolor: 'success',
    route: 'starter/salesman',
  },
  {
    displayName: 'Installer',
    iconName: 'user-cog',
    bgcolor: 'error',
    route: 'starter/installer',
  },
  {
    displayName: 'Notification',
    iconName: 'bell',
    bgcolor: 'warning',
    route: 'starter/notification',
  },
  {
    displayName: 'Masters',
    iconName: 'database-cog',
    bgcolor: 'error',
    route: 'masters',
    children: [
      {
        displayName: 'City',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'masters/city',
      },
      {
        displayName: 'Category',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'masters/category',
      },
      {
        displayName: 'Products',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'masters/products',
      },
    ]
  },
  {
    displayName: 'Reports',
    iconName: 'clipboard-list',
    bgcolor: 'accent',
    route: 'starter/reports',
    children: [
      {
        displayName: 'Task Report',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'starter/reports/task-report',
      },
      {
        displayName: 'City Wise Task Report',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'starter/reports/city-task-report',
      },
      {
        displayName: 'Payment Summary',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'starter/reports/paid-unpiad-report',
      },
      {
        displayName: 'Location Summary',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'starter/reports/location-summary',
      },
    ],
  },
]

// This Menu for 'Salesman'
export const navItems3: NavItem[] = [
  {
    displayName: 'Dashboard',
    iconName: 'layout-dashboard',
    bgcolor: 'success',
    route: '/dashboards/dashboard',
  },
  {
    displayName: 'Task',
    iconName: 'list-details',
    bgcolor: 'accent',
    route: 'tasks',
    children: [
      {
        displayName: 'Add Task',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'tasks/add-edit-task/0',
      },
      {
        displayName: 'Pending',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'tasks/task-management/Pending',
      },
      {
        displayName: 'Accepted',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'tasks/task-management/Accepted',
      },
      {
        displayName: 'Started',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'tasks/task-management/Started',
      },
      {
        displayName: 'On Hold',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'tasks/task-management/On Hold',
      },
      {
        displayName: 'Completed',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'tasks/task-management/Completed',
      },
      {
        displayName: 'Cancel',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'tasks/task-management/Cancel',
      },
    ]
  },
  {
    displayName: 'Go To Home',
    iconName: 'home',
    bgcolor: 'success',
    route: 'starter/go-to-home',
  },
  {
    displayName: 'Installer',
    iconName: 'user-cog',
    bgcolor: 'error',
    route: 'starter/installer',
  },
  {
    displayName: 'Notification',
    iconName: 'bell',
    bgcolor: 'warning',
    route: 'starter/notification',
  },
  {
    displayName: 'Masters',
    iconName: 'database-cog',
    bgcolor: 'error',
    route: 'masters',
    children: [
      {
        displayName: 'Products',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'masters/products',
      },
    ]
  },
  {
    displayName: 'Reports',
    iconName: 'clipboard-list',
    bgcolor: 'accent',
    route: 'starter/reports',
    children: [
      {
        displayName: 'Task Report',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'starter/reports/task-report',
      },
      {
        displayName: 'City Wise Task Report',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'starter/reports/city-task-report',
      },
      {
        displayName: 'Payment Summary',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'starter/reports/paid-unpiad-report',
      },
      {
        displayName: 'Location Summary',
        iconName: 'point',
        bgcolor: 'tranparent',
        route: 'starter/reports/location-summary',
      },
    ],
  },
]

// This Menu for 'Accountant'
export const navItems4: NavItem[] = [
  {
    displayName: 'Dashboard',
    iconName: 'layout-dashboard',
    bgcolor: 'success',
    route: '/dashboards/dashboard',
  },
  {
    displayName: 'User',
    iconName: 'users',
    bgcolor: 'primary',
    route: 'starter/user',
  },
  {
    displayName: 'Expense',
    iconName: 'calendar-dollar',
    bgcolor: 'success',
    route: 'starter/expense',
  },
  {
    displayName: 'Reports',
    iconName: 'clipboard-list',
    bgcolor: 'error',
    route: 'starter/reports',
    children: [
      {
        displayName: 'Expense Report',
        iconName: 'plus',
        bgcolor: 'tranparent',
        route: 'starter/reports/expense-report',
      },
    ],
  },
]